import { ILayerFactory } from "./ILayerFactory";
import { Tile } from "ol/layer";
import { XYZ } from "ol/source";
import TileLayer from "ol/layer/Tile";
import { Map } from "ol";
import { SelectedFeatureInfo } from "../SelectedFeatureInfo";
import { MapContextMenuItem } from "../MapContextMenuItem";
import { LayerUtil } from "../util/LayerUtil"

/**
 * 国土地理院標準地図レイヤクラス
 */
export class StdMapTileLayerFactory implements ILayerFactory {
  /**
   * 国土地理院標準地図レイヤ
   */
  private _layer: Tile<XYZ>;

  /**
   * 国土地理院標準地図レイヤコンストラクタ
   */
  constructor() {
    this._layer = new Tile({
      source: new XYZ({
        url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
        crossOrigin: "Anonymous",
      }),
    });
  }

  /**
   * 地物属性の有無を取得
   */
  isFeatureInfo(): boolean {
    return false;
  }

  /**
   * 範囲地物属性の有無を取得
   */
  isRangeFeatureInfo(): boolean {
    return false;
  }

  /**
   * 右クリック処理の有無を取得
   */
  isRightClickInfo(): boolean {
    return false;
  }

  /**
   * レイヤ定義を取得
   */
  getViewLayer(): TileLayer<XYZ>[] {
    return [this._layer];
  }

  /**
   * 地物情報を取得
   * @param map 地図
   * @param layerNames レイヤ名リスト
   * @param latitude クリック座標緯度
   * @param longitude クリック座標経度
   * @param x クリック位置X
   * @param y クリック位置Y
   * @param width 地図幅
   * @param height 地図高さ
   * @param bBox 地図範囲（BBOX)
   * @param currentTime 対象時間
   */
  async getFeatureInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return [];
  }

  /**
   * 右クリック処理
   * @param map 地図
   * @param layerNames レイヤ名リスト
   * @param latitude クリック座標緯度
   * @param longitude クリック座標経度
   * @param x クリック位置X
   * @param y クリック位置Y
   * @param width 地図幅
   * @param height 地図高さ
   * @param bBox 地図範囲（BBOX)
   * @param currentTime 対象時間
   */
  async getRightClickInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<MapContextMenuItem[]> {
    return null;
  }

  /**
   * 指定範囲の地物を取得
   * @param map 地図
   * @param layerNames レイヤ名リスト
   * @param bBox 地図範囲（BBOX)
   * @param currentTime 対象時間
   */
  async getRangeFeatureInfo(
    _map: Map,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return [];
  }

  /**
   * 表示中のレイヤ数を取得
   */
  getVisibleLayerCount(): number {
    return this._layer.getVisible() ? 1 : 0;
  }
  /**
   * 表示レイヤが存在するか判定
   */
   isVisibleLayer(_map:Map) {
    return LayerUtil.isVisibleLayer(_map, this._layer)
  }
}
